import React from "react";
import Sidebar from "../components/sidebar";
import Notification from "../components/Notification";
import ProfileDropdown from "../components/ProfileDropdown";
import "../styles/Dashboard.css"; // Menggunakan style dari Dashboard agar seragam
import "../styles/CCTV.css"; // Menggunakan style dari Dashboard agar seragam

const CCTV = () => {
  return (
    <div className="cctv-container">
      {/* Header CCTV */}
      <div className="dashboard-header">
        <h2 className="header-title">📹 CCTV Monitoring</h2>
        <div className="header-right">
          <Notification />
          <ProfileDropdown />
        </div>
      </div>

      <Sidebar />

      <div className="cctv-content">
        <p>Live monitoring depot air minum.</p>

        {/* Grid untuk menampilkan 3 kamera */}
        <div className="cctv-grid">
          <div className="cctv-video-container">
            <video controls autoPlay loop muted className="cctv-video">
              <source src="https://www.w3schools.com/html/mov_bbb.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p>🔧 CCTV 1 - Area Produksi</p>
          </div>

          <div className="cctv-video-container">
            <video controls autoPlay loop muted className="cctv-video">
              <source src="https://www.w3schools.com/html/mov_bbb.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p>🔧 CCTV 2 - Penyimpanan</p>
          </div>

          <div className="cctv-video-container">
            <video controls autoPlay loop muted className="cctv-video">
              <source src="https://www.w3schools.com/html/mov_bbb.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p>🔧 CCTV 3 - Area Parkir</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CCTV;